<script setup lang="ts">
import type { FineUploaderUpload } from '@/models/current-student-advanced-standing-form/api'
import UploadAlert from '@/components/current-student-advanced-standing-form/upload/UploadAlert.vue'
import UploadDropZone from '@/components/current-student-advanced-standing-form/upload/UploadDropZone.vue'
import UploadQueue from '@/components/current-student-advanced-standing-form/upload/UploadQueue.vue'

defineProps<{
  uploaderId: string
  visible: boolean
  attachments: FineUploaderUpload[]
  dropActive: boolean
  alertMessage: string
  uploadThumbnailUrl: (attachment: FineUploaderUpload) => string
}>()

const emit = defineEmits<{
  dragEnter: [event: DragEvent]
  dragOver: [event: DragEvent]
  dragLeave: [event: DragEvent]
  drop: [event: DragEvent]
  triggerUploadInput: [event: MouseEvent]
  uploadButtonKeydown: [event: KeyboardEvent]
  uploadButtonHover: [event: MouseEvent, hover: boolean]
  uploadButtonFocus: [event: FocusEvent, focused: boolean]
  fileSelected: [event: Event]
  cancelStagedUpload: [attachment: FineUploaderUpload]
  retryUpload: [attachment: FineUploaderUpload]
  deleteStagedUpload: [attachment: FineUploaderUpload]
  closeAlert: []
}>()
</script>

<template>
  <div :id="uploaderId" v-show="visible">
    <div
      class="qq-uploader-selector qq-uploader qq-gallery"
      :qq-drop-area-text="attachments.length === 0 ? 'Drop files here' : null"
      @dragenter="emit('dragEnter', $event)"
      @dragover="emit('dragOver', $event)"
      @dragleave="emit('dragLeave', $event)"
      @drop="emit('drop', $event)"
    >
      <UploadDropZone
        :drop-active="dropActive"
        @trigger-upload-input="emit('triggerUploadInput', $event)"
        @upload-button-keydown="emit('uploadButtonKeydown', $event)"
        @upload-button-hover="(event, hover) => emit('uploadButtonHover', event, hover)"
        @upload-button-focus="(event, focused) => emit('uploadButtonFocus', event, focused)"
        @file-selected="emit('fileSelected', $event)"
      />
      <UploadQueue
        :attachments="attachments"
        :upload-thumbnail-url="uploadThumbnailUrl"
        @cancel-staged-upload="emit('cancelStagedUpload', $event)"
        @retry-upload="emit('retryUpload', $event)"
        @delete-staged-upload="emit('deleteStagedUpload', $event)"
      />
      <UploadAlert
        :alert-message="alertMessage"
        @close-alert="emit('closeAlert')"
      />
    </div>
  </div>
</template>
